import { render, staticRenderFns } from "./WeekCalendar.vue?vue&type=template&id=9bbbc2ea&scoped=true"
import script from "./WeekCalendar.vue?vue&type=script&lang=js"
export * from "./WeekCalendar.vue?vue&type=script&lang=js"
import style0 from "./WeekCalendar.vue?vue&type=style&index=0&id=9bbbc2ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bbbc2ea",
  null
  
)

export default component.exports